import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import LandingPage from './components/LandingPage';
import CookieBanner from './components/CookieBanner';
import ThemeWave from './components/ThemeWave';

// Lazy load legal pages for better initial bundle size
const Impressum = lazy(() => import('./pages/Impressum'));
const Datenschutz = lazy(() => import('./pages/Datenschutz'));
const AGB = lazy(() => import('./pages/AGB'));
const UeberUns = lazy(() => import('./pages/UeberUns'));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen bg-[#030303] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin" />
  </div>
);

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

/**
 * Main App Component
 * Uses BrowserRouter for Netlify (clean URLs without #)
 * Netlify handles SPA routing via netlify.toml redirects
 * Legal pages are lazy loaded for performance
 */
function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        {/* The magical wave animation layer */}
        <ThemeWave />
        
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={
            <Suspense fallback={<PageLoader />}>
              <Impressum />
            </Suspense>
          } />
          <Route path="/datenschutz" element={
            <Suspense fallback={<PageLoader />}>
              <Datenschutz />
            </Suspense>
          } />
          <Route path="/agb" element={
            <Suspense fallback={<PageLoader />}>
              <AGB />
            </Suspense>
          } />
          <Route path="/ueber-uns" element={
            <Suspense fallback={<PageLoader />}>
              <UeberUns />
            </Suspense>
          } />
        </Routes>
        {/* Cookie Banner appears on all pages */}
        <CookieBanner />
      </Router>
    </ThemeProvider>
  );
}

export default App;
